export default __webpack_public_path__ + "static/media/io.450b2f1e.jpg";